import { ParentProps, createContext, createEffect, createSignal } from 'solid-js'
import { requireContext } from 'common'
import { K12GradreqThresholdContext } from './K12GradreqThresholdContext'
import styles from './sis-k12-gradreq-threshold.module.css'
import K12GradreqThresholdAPI from '../../api/sis-k12-gradreq-threshold'
import { Input, STComponentWrapperProps, requireViewContext } from 'st-app';
import { ViewContext } from 'st-app/components/st-view/ViewContext';
import { Part, createStore } from 'solid-js/store';
import { GradReqThresholdData } from '../../api'
import internal from 'stream'

const K12GradreqThresholdContextJsx = createContext<K12GradreqThresholdContext>();
export const requireK12GradreqThresholdContext = () => {
    return requireContext(K12GradreqThresholdContextJsx);
}

export class K12GradreqThresholdProps extends STComponentWrapperProps { }

export default function K12GradreqThreshold(props: ParentProps<K12GradreqThresholdProps>) {
    const context = new K12GradreqThresholdContext();

    return (
        <K12GradreqThresholdContextJsx.Provider value={context}>
            <K12GradreqThresholdInternal {...props} />
        </K12GradreqThresholdContextJsx.Provider>
    )
}

function K12GradreqThresholdInternal(props: ParentProps<K12GradreqThresholdProps>) {
    const [thresholdProps, setThresholdProps] = createStore<GradReqThresholdData>(new GradReqThresholdData())
    const [lowValue, setLowValue] = createSignal<number | undefined>(0)
    const [highValue, setHighValue] = createSignal<number | undefined>(0)



    const viewCtx: ViewContext = requireViewContext()

    createEffect(() => {
        if (props.value) {
            K12GradreqThresholdAPI.DeserializeProps(props.value).then(p => {
                if (p.lowValue != undefined && p.lowValue < p.minValue) {
                    p.lowValue = p.minValue
                }

                if (p.lowValue != undefined && p.lowValue > p.maxValue) {
                    p.lowValue = p.maxValue
                }

                if (p.highValue != undefined && p.highValue > p.maxValue) {
                    p.highValue = p.maxValue
                }

                if (p.highValue != undefined && p.highValue < p.minValue) {
                    p.highValue = p.minValue
                }

                setThresholdProps(p)
                setLowValue(p.lowValue)
                setHighValue(p.highValue)
            })
        }
    })

    const updateValues = (property: Part<GradReqThresholdData, keyof GradReqThresholdData>, e: Event & {currentTarget: HTMLInputElement, target: HTMLInputElement}) => {
        var val: number = thresholdProps.minValue
        if (thresholdProps.enforceInteger) {
            val = parseInt(e.target.value)
        } else {
            val = parseFloat(e.target.value)
        }

        if (val < thresholdProps.minValue) {
            val = thresholdProps.minValue
        }

        if (val > thresholdProps.maxValue) {
            val = thresholdProps.maxValue
        }

        if (property == "lowValue") {
            if (highValue() != undefined && val > highValue()!) {
                val = highValue()!;
            }
            setLowValue(val)
        }
        else {
            if (lowValue() != undefined && val < lowValue()!) {
                val = lowValue()!;
            }
            setHighValue(val)
        }
        setThresholdProps(property, val)
        

        viewCtx.events.setValue(JSON.stringify(thresholdProps))
        e.currentTarget.value = val.toString()
    }

    return (
        <div class={styles['sis-k12-gradreq-threshold']}>
            <span class={styles['threshold-title']}>{thresholdProps.title}</span>
            <div class={styles['value-labels']}>
                <div class={styles['legend']}>
                    <div class={styles['legend-item']}>
                        <div class={`${styles['legend-color']} ${styles['legend-low']}`}></div>
                        <span class={styles["legend-text"]}>
                            Off Track &lt; <input type='number' inputmode="decimal" name='low' onChange={(e) => updateValues("lowValue", e)} {...({ 'prop:value': lowValue() } as any)} min={thresholdProps.minValue} max={highValue()} step={thresholdProps.step} />
                        </span>
                    </div>
                    <div class={styles['legend-item']}>
                        <div class={`${styles['legend-color']} ${styles['legend-mid']}`}></div>
                        <span class={styles['legend-text']}>
                            At Risk
                            <input type='number' inputmode="decimal" name='low' onChange={(e) => updateValues("lowValue", e)} {...({ 'prop:value': lowValue() } as any)} min={thresholdProps.minValue} max={highValue()} step={thresholdProps.step} />
                            -
                            <input type='number' inputmode="decimal" name='high' onChange={(e) => updateValues("highValue", e)} {...({ 'prop:value': highValue() } as any)} min={lowValue()} max={thresholdProps.maxValue} step={thresholdProps.step} />
                        </span>
                    </div>
                    <div class={styles['legend-item']}>
                        <div class={`${styles['legend-color']} ${styles['legend-high']}`}></div>
                        <span class={styles["legend-text"]}>
                            On Track &gt;= <input type='number' inputmode="decimal" name='high' onChange={(e) => updateValues("highValue", e)} {...({ 'prop:value': highValue() } as any)} min={lowValue()} max={thresholdProps.maxValue} step={thresholdProps.step} />
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );
}

K12GradreqThreshold.defaultProps = new K12GradreqThresholdProps();